import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { SaveForLater } from "../../components/saveForLater";
import AllJobsWrapper from "../../StylesWrappers/AllJobs/showAllJobs";
import { AppDispatch, RootState } from "../../store";
import {
  deleteSaveAction,
  saveForLaterAction,
} from "../../features/saveForLater/saveForLaterSlice";
import Overlay from "../../components/General/overlay";
import Loader from "../../components/General/Loader";
import {
  setCloseConfirmationModal,
  setOpenConfirmationModal,
  setPostJobId,
} from "../../features/general/generalSlice";

const SaveForLaterPage = () => {
  const { saveForLater, isSaveDeleteLoading } = useSelector(
    (store: RootState) => store.saveForLaterStore
  );
  const { postJobId } = useSelector((store: RootState) => store.generalStore);

  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  // Initial save for later modal
  const initialRemoveSaveForLater = (index: string) => {
    // console.log(index);
    dispatch(setPostJobId(index));
    dispatch(setOpenConfirmationModal());
  };

  // Remove job from save for later
  const handleRemoveSaveForLater = () => {
    dispatch(setCloseConfirmationModal());

    // Remove from save for later if only in save-for-later page
    if (pathname.includes("save-for-later")) {
      // console.log(index);
      dispatch(deleteSaveAction(postJobId));
    }
  };

  // Job details while on save for later page
  const handleJobDetails = (index: string) => {
    // console.log(index);
    navigate(`/dashboard/all-post-jobs/${index}`);
  };

  // Fetch all save for later
  useEffect(() => {
    dispatch(saveForLaterAction());
  }, [dispatch]);

  return (
    <>
      {isSaveDeleteLoading && (
        <Overlay>
          <Loader loaderStyle={""} />
        </Overlay>
      )}
      <AllJobsWrapper>
        <p style={{ fontSize: "2rem", fontWeight: 600, marginBlock: "1rem" }}>
          {saveForLater.length} Saved Job{saveForLater.length <= 1 ? "" : "s"}
        </p>
        <SaveForLater
          handleJobDetails={handleJobDetails}
          initialRemoveSaveForLater={initialRemoveSaveForLater}
          handleRemoveSaveForLater={handleRemoveSaveForLater}
        />
      </AllJobsWrapper>
    </>
  );
};

export default SaveForLaterPage;
